import axios from "axios";

/**@Constants */
import { base_URL } from "../config/config";

// Function to fetch vendor response time
export const fetchVenueResponseTime = async (venueId) => {
  try {
    const { data } = await axios.get(
      `${base_URL}/api/venue-response-time/${venueId}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching response time:", error.message);
    return { averageResponseTime: 0, totalEnquiries: 0 };
  }
};